import { DragDropChangeValue } from "components";
import { moveElementInArray } from "helpers";
import { BoxShadowLayout, ContentLayout } from "layouts";
import { useRefetchQuery } from "libs/reactQuery";
import { useState, useEffect } from "react";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";

import {
  useGetDeliveryPriority,
  useReorderDeliveryPriority
} from "../../apis";
import { DeliveryPriorityTable } from "../../components";
import { DeliveryPriorityItem } from "../../deliveryPriority.types";

import styles from "./DeliveryPriority.module.scss";

const DeliveryPriority = () => {
  const { t } = useTranslation();

  const { items, isLoading } = useGetDeliveryPriority();
  const refetchPriority = useRefetchQuery(useGetDeliveryPriority.queryKey);

  const [localItems, setLocalItems] = useState<DeliveryPriorityItem[]>([]);

  useEffect(() => {
    setLocalItems(items);
  }, [items]);

  const reorderMutation = useReorderDeliveryPriority({
    onSuccess: () => {
      refetchPriority();
    },
    onError: () => {
      toast.error(t("Failed to update priority"));
      refetchPriority();
    }
  });

  const onReorder = (value: DragDropChangeValue) => {
    const next = moveElementInArray({
      array: localItems,
      fromIndex: value.fromIndex,
      toIndex: value.toIndex,
      keyForReorder: "position"
    });

    setLocalItems(next);

    reorderMutation.mutate({
      positions: next.map((item, index) => ({ id: item.id, position: index }))
    });
  };

  return (
    <ContentLayout title={t("Delivery Priority")}>
      <BoxShadowLayout>
        <div className={styles.deliveryPriority}>
          <div className={styles.deliveryPriority__hint}>
            {t(
              "Drag to reorder delivery companies and independent drivers. The top entries are auto-assigned to new orders first."
            )}
          </div>
          <DeliveryPriorityTable
            items={localItems}
            isLoading={isLoading}
            onReorder={onReorder}
          />
        </div>
      </BoxShadowLayout>
    </ContentLayout>
  );
};

export default DeliveryPriority;
